import React from 'react';

// - Add '.fill' to all body classes.
// - Add '.tail' <g> around tail. Remember to add '.fill' to tail shape so that:
	// <g .tail > <path .fill /> </g>

export default function Bodies() {
	return (
		<g>
			<path className="fill fill--black penguin--wing penguin--wing--left" d="M196.9253082,188.8121033c-17.03125,18.3716278-28.6724396,54.885498-28.6724396,86.0325012
				c0,11.4630737,2.3295746,24.9998474,6.5444946,38.0345764c0.791626,2.6525879,3.5147247,8.256897,10.5464478,6.9443665
				c5.3550262-0.9995728,7.6847992-10.9397583,8.2038574-33.4861755l0.0105438-0.1288757
				c0.2108459-2.336853,0.5123444-4.798645,0.9224243-7.5255432c1.464798-9.7567749,4.3986206-18.9042969,9.2310333-28.7869568
				c2.1811218-4.4510651,16.1586456-29.1740417,16.7521667-30.2242279c0.3673859-0.6596375,0.6236115-1.4688873,0.9666901-2.0692596
				C238.9804993,186.8903656,211.5692139,173.0157013,196.9253082,188.8121033z" />
			<path className="fill fill--black penguin--wing penguin--wing--right" d="M311.074707,188.8121033c17.03125,18.3716278,28.6724243,54.885498,28.6724243,86.0325012
				c0,11.4630737-2.3295593,24.9998474-6.5444946,38.0345764c-0.791626,2.6525879-3.51474,8.256897-10.5464478,6.9443665
				c-5.3550415-0.9995728-7.6848145-10.9397583-8.2038574-33.4861755l-0.0105591-0.1288757
				c-0.2108154-2.336853-0.5123291-4.798645-0.9223938-7.5255432c-1.4648132-9.7567749-4.3986206-18.9042969-9.2310486-28.7869568
				c-2.1811218-4.4510651-16.1586609-29.1740417-16.7521667-30.2242279
				c-0.3673706-0.6596375-0.6236267-1.4688873-0.9666748-2.0692596
				C269.0195007,186.8903656,296.4307861,173.0157013,311.074707,188.8121033z" />
			<g className="body">
				<path className="fill fill--white" d="M254,198.9755096c18.0625305,0,35.7052612-11.6563416,47.2984314,2.2769928
					c14.9534912,17.9719543,25.3825989,53.8635864,25.3825989,82.3667603c0,75.8895874-48.9959717,78.9524841-48.9959717,78.9524841
					c-6.8857117,2.1470032-40.3427277,2.1683044-47.1703033,0.0619812c0,0-49.1957855-3.1248779-49.1957855-79.0144653
					c0-28.5031738,10.4290924-64.3948059,25.3825836-82.3667603C219.4226074,185.963623,235.9374695,198.9755096,254,198.9755096z" />
			</g>
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/TuxedoBird/Bodies.js